import { ValidationResult } from './validation-result.model';
import { Category } from '../models/category.model';
import { DEFAULT_CATEGORY_ID } from '../constants/app.constants';

export function validateCategory(category: Category): ValidationResult {
  const errors: string[] = [];

  if (typeof category.id !== 'string' || category.id.trim() === '') {
    errors.push('Category ID must be a non-empty string.');
  }

  if (typeof category.name !== 'string' || category.name.trim() === '') {
    errors.push('Category name cannot be empty.');
  }

  if (typeof category.color !== 'string' || !/^#[0-9A-Fa-f]{6}$/i.test(category.color)) {
    errors.push('Category color is invalid.');
  }

  if (typeof category.isSystem !== 'boolean') {
    errors.push('Category system flag is invalid.');
  }

  return { isValid: errors.length === 0, errors };
}

export function validateCategoryCreate(category: Category, existingCategories: Category[]): ValidationResult {
  const errors = [...validateCategory(category).errors];

  if (existingCategories.some(c => c.id === category.id)) {
    errors.push('Category ID already exists.');
  }

  return { isValid: errors.length === 0, errors };
}

export function validateCategoryEdit(category: Category, originalCategory: Category, existingCategories: Category[]): ValidationResult {
  const errors = [...validateCategory(category).errors];

  if (category.id !== originalCategory.id) {
    errors.push('Category ID cannot be changed.');
  }
  if (originalCategory.id === DEFAULT_CATEGORY_ID && category.name.trim() !== originalCategory.name) {
    errors.push('System Uncategorized category cannot be renamed.');
  }

  return { isValid: errors.length === 0, errors };
}

export function validateCategoryDelete(categoryId: string, cardsUsingAssignedCategory: number, replacementCategoryId?: string | null): ValidationResult {
  const errors: string[] = [];

  if (categoryId === DEFAULT_CATEGORY_ID) {
    errors.push('System Uncategorized category cannot be deleted.');
  }

  if (cardsUsingAssignedCategory > 0) {
    if (!replacementCategoryId) {
      errors.push('Replacement category is required when deleting an active category.');
    } else if (replacementCategoryId === categoryId) {
      errors.push('Replacement category cannot be the same as the deleted category.');
    }
  }

  return { isValid: errors.length === 0, errors };
}
